var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabRoiThreshold = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 22,
  viewBox: "0 0 23 22",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.34 11.74-2.971.425.425-2.971 7.64-7.64A1.8 1.8 0 1 1 20.98 4.1l-7.64 7.64zm-4.696 7.294h7.383c.865 0 1.566-.701 1.566-1.566V10.03m-5.089-5.09H5.066C4.2 4.94 3.5 5.643 3.5 6.508V8.48",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "m11.5 8.5 2.333 2.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1 14 2.5-2.5L6 14m-5 3.5L3.5 20 6 17.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z"
}))));
export { SvgTabRoiThreshold as ReactComponent };
export default __webpack_public_path__ + "assets/images/tab-roi-threshold.svg";